/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AmountDecimal,
  AmountDecimal$inboundSchema,
  AmountDecimal$Outbound,
  AmountDecimal$outboundSchema,
} from "./amountdecimal.js";
import {
  TransferLineItemImageMetadata,
  TransferLineItemImageMetadata$inboundSchema,
  TransferLineItemImageMetadata$Outbound,
  TransferLineItemImageMetadata$outboundSchema,
} from "./transferlineitemimagemetadata.js";

/**
 * Represents a modifier or option applied to a line item.
 */
export type TransferLineItemOption = {
  /**
   * The name of the option or modifier.
   */
  name: string;
  /**
   * The quantity of this option.
   */
  quantity: number;
  /**
   * Optional price modification applied by this option. Can be positive, negative, or zero.
   */
  priceModifier?: AmountDecimal | undefined;
  /**
   * Optional list of images associated with this line item option.
   */
  images?: Array<TransferLineItemImageMetadata> | undefined;
  /**
   * Optional group identifier to categorize related options (e.g., 'toppings').
   */
  group?: string | undefined;
};

/** @internal */
export const TransferLineItemOption$inboundSchema: z.ZodType<
  TransferLineItemOption,
  z.ZodTypeDef,
  unknown
> = z.object({
  name: z.string(),
  quantity: z.number().int(),
  priceModifier: AmountDecimal$inboundSchema.optional(),
  images: z.array(TransferLineItemImageMetadata$inboundSchema).optional(),
  group: z.string().optional(),
});
/** @internal */
export type TransferLineItemOption$Outbound = {
  name: string;
  quantity: number;
  priceModifier?: AmountDecimal$Outbound | undefined;
  images?: Array<TransferLineItemImageMetadata$Outbound> | undefined;
  group?: string | undefined;
};

/** @internal */
export const TransferLineItemOption$outboundSchema: z.ZodType<
  TransferLineItemOption$Outbound,
  z.ZodTypeDef,
  TransferLineItemOption
> = z.object({
  name: z.string(),
  quantity: z.number().int(),
  priceModifier: AmountDecimal$outboundSchema.optional(),
  images: z.array(TransferLineItemImageMetadata$outboundSchema).optional(),
  group: z.string().optional(),
});

export function transferLineItemOptionToJSON(
  transferLineItemOption: TransferLineItemOption,
): string {
  return JSON.stringify(
    TransferLineItemOption$outboundSchema.parse(transferLineItemOption),
  );
}
export function transferLineItemOptionFromJSON(
  jsonString: string,
): SafeParseResult<TransferLineItemOption, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TransferLineItemOption$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TransferLineItemOption' from JSON`,
  );
}
